export default "__VITE_ASSET__kQzwL_LM__";